import React from "react";
import { useState, useEffect } from "react";
import AIheader from '../RentAI/AIheader';
import Footer from '../../Component/Footer/Footer';
import '../Terms/TermsStyle.css';
import '../Privacy/Privacy.css';

import ScrollingAnounce from '../../Component/GetAroundpage/ScrollingAnounce/ScrollingAnounce'

const menuItems = [
    { id: "roadside_intro", text: "Introduction" },
    { id: "roadside_1", text: "Definitions" },
    { id: "roadside_2", text: "Roadside Service Availability" },
    { id: "roadside_3", text: "Roadside Plan Benefits" },
    { id: "roadside_4", text: "Benefit Period" },
    { id: "roadside_5", text: "Requesting Roadside Assistance" },
    { id: "roadside_6", text: "Roadside Services Are Not Emergency Services" },
    { id: "roadside_7", text: "Vehicle Attendance and Safety" },
    { id: "roadside_8", text: "Third-Party Administration and Independent Service Providers" },
    { id: "roadside_9", text: "No Guarantee of Successful Service" },
    { id: "roadside_10", text: "Prior Authorization Required" },
    { id: "roadside_11", text: "Reimbursement of Authorized Services" },
    { id: "roadside_12", text: "Towing Assistance" },
    { id: "roadside_13", text: "Repair Facilities and Towing Destinations" },
    { id: "roadside_14", text: "Flat Tire Assistance" },
    { id: "roadside_15", text: "Fuel, Oil, Fluid, and Water Delivery" },
    { id: "roadside_16", text: "Lockout Assistance" },
    { id: "roadside_17", text: "Battery Assistance" },
    { id: "roadside_18", text: "Electric and Hybrid Vehicles" },
    { id: "roadside_19", text: "Winching and Extrication Assistance" },
    { id: "roadside_20", text: "Vehicle Eligibility" },
    { id: "roadside_21", text: "Customer Approval and Payment of Additional Charges" },
    { id: "roadside_22", text: "Payment Authorization" },
    { id: "roadside_23", text: "Cancellation and Refunds" },
    { id: "roadside_24", text: "General Exclusions" },
    { id: "roadside_25", text: "Service Availability and Delays" },
    { id: "roadside_26", text: "Customer Responsibilities" },
    { id: "roadside_27", text: "Roadside Services Apply Only to the Covered Vehicle" },
    { id: "roadside_28", text: "Occurrence Limits" },
    { id: "roadside_29", text: "Abuse, Fraud, and Misuse" },
    { id: "roadside_30", text: "Not Insurance or a Vehicle Warranty" },
    { id: "roadside_31", text: "Disclaimer of Warranties" },
    { id: "roadside_32", text: "Limitation of Liability" },
    { id: "roadside_33", text: "Indemnification" },
    { id: "roadside_34", text: "Changes to Roadside Services" },
    { id: "roadside_35", text: "Electronic Communications and Acceptance" },
    { id: "roadside_36", text: "Relationship to Rentid’s General Terms" },
    { id: "roadside_37", text: "Assignment" },
    { id: "roadside_38", text: "Severability" },
    { id: "roadside_39", text: "No Waiver" },
    { id: "roadside_40", text: "Headings" },
    { id: "roadside_41", text: "Entire Agreement" },
    { id: "roadside_42", text: "Contact Information" },
    { id: "roadside_43", text: "Acceptance of Terms" },
];

const RoadsideTerms = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            let scrollPosition = window.scrollY - 400; // Adjust offset for better accuracy
            let foundIndex = 0;

            menuItems.forEach((item, index) => {
                const section = document.getElementById(item.id);
                if (section) {
                    const offsetTop = section.offsetTop;
                    if (scrollPosition >= offsetTop) {
                        foundIndex = index;
                    }
                }
            });

            setActiveIndex(foundIndex);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

  return (
    <>

<AIheader/>
<main className="mainNew">

    <section className='termsBanner'>
        <h1>Roadside Terms of Service</h1>
    </section>

    {/* START maxBannerMain */}
    <section className="privacyMain">
        <div className="container">
            <div className='row'>
                <div className='col-lg-3 col-md-3 col-sm-12'>
                    <div className='privacyLeft'>
                        <ul>
                            {menuItems.map((item, index) => (
                                <li
                                    key={item.id}
                                    className={index === activeIndex ? "active" : ""}
                                    onClick={() => setActiveIndex(index)}
                                >
                                    <a href={`#${item.id}`}>{item.text}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className='col-lg-9 col-md-9 col-sm-12'>
                    <div className='privacyRight'>

                        <div className='privacyData' id='roadside_intro'>
                            <h2>Introduction</h2>
                            <p>These Rentid Roadside Services Terms and Conditions (“Roadside Terms”) govern the purchase, selection, activation, administration, and use of Rentid Roadside Services.</p>
                            <p>Rentid Roadside Services provides access to roadside assistance for an eligible vehicle associated with a rental, booking, or roadside service transaction. The specific services, limits, towing options, geographic availability, customer responsibilities, and other benefits available to you are determined by the roadside plan selected for the applicable transaction.</p>
                            <p>By purchasing, selecting, activating, requesting, or using Rentid Roadside Services, you agree to these Roadside Terms and the specific roadside plan details presented to you during checkout, booking, rental confirmation, or activation.</p>
                        </div>

                        <div className='privacyData' id='roadside_1'>
                            <h2>Definitions</h2>
                            <p>For purposes of these Roadside Terms:</p>
                            <p><strong>“Authorized Driver”</strong> means a person who is permitted to operate the Covered Vehicle under the applicable rental agreement, booking, vehicle owner requirements, and applicable law.</p>
                            <p><strong>“Covered Emergency”</strong> means an unexpected vehicle disablement or roadside event that qualifies for assistance under the selected Roadside Plan and these Roadside Terms.</p>
                            <p><strong>“Covered Vehicle”</strong> means the eligible vehicle identified in the applicable rental, booking, roadside service selection, or transaction.</p>
                            <p><strong>“Dispatch Center”</strong> means the authorized roadside assistance dispatch service through which Roadside Services must be requested.</p>
                            <p><strong>“Occurrence”</strong> means a roadside service event arising from a single breakdown, vehicle condition, incident, or related series of circumstances. Multiple service requests resulting from the same underlying condition may be treated as one Occurrence.</p>
                            <p><strong>“Rentid,” “we,” “us,” or “our”</strong> means Rentid, Inc. and, where applicable, its affiliates and authorized program administrators.</p>
                            <p><strong>“Roadside Plan”</strong> means the specific roadside assistance option selected or included with an eligible rental, booking, or vehicle transaction.</p>
                            <p><strong>“Roadside Services”</strong> means the roadside assistance services made available through Rentid under the selected Roadside Plan.</p>
                            <p><strong>“Service Provider”</strong> means an independent towing company, roadside technician, locksmith, repair facility, recovery provider, or other third party dispatched to provide Roadside Services.</p>
                            <p><strong>“You” or “your”</strong> means the person who purchases, selects, activates, requests, or uses Roadside Services and, where applicable, the Authorized Driver of the Covered Vehicle.</p>
                        </div>

                        <div className='privacyData' id='roadside_2'>
                            <h2>Roadside Service Availability</h2>
                            <p>Roadside Services are generally available 24 hours a day, every day of the year, within eligible service areas in the United States and Canada.</p>
                            <p>Availability is not guaranteed and is subject to:</p>
                            <ul>
                                <li>The Roadside Plan selected</li>
                                <li>The location of the Covered Vehicle</li>
                                <li>Service Provider availability</li>
                                <li>Vehicle accessibility</li>
                                <li>Road and traffic conditions</li>
                                <li>Weather conditions</li>
                                <li>Local restrictions</li>
                                <li>Safety requirements</li>
                                <li>Applicable laws</li>
                                <li>Public emergencies</li>
                                <li>Equipment requirements</li>
                                <li>These Roadside Terms</li>
                            </ul>
                            <p>Roadside Services are available only for a Covered Vehicle and may be requested only by or on behalf of an Authorized Driver.</p>
                        </div>

                        <div className='privacyData' id='roadside_3'>
                            <h2>Roadside Plan Benefits</h2>
                            <p>Roadside Plans may provide different levels of service and may include different:</p>
                            <ul>
                                <li>Covered services</li>
                                <li>Towing options</li>
                                <li>Towing destinations</li>
                                <li>Service limits</li>
                                <li>Benefit amounts</li>
                                <li>Occurrence limits</li>
                                <li>Vehicle eligibility requirements</li>
                                <li>Geographic service areas</li>
                                <li>Customer payment responsibilities</li>
                                <li>Exclusions</li>
                                <li>Additional restrictions</li>
                            </ul>
                            <p>The Roadside Plan details displayed during checkout, booking, rental confirmation, or activation determine the specific benefits available for the applicable transaction.</p>
                            <p>The availability of a service within these general Roadside Terms does not mean that the service is included in every Roadside Plan.</p>
                            <p>If these Roadside Terms conflict with the specific Roadside Plan details presented for a transaction, the specific Roadside Plan details will control regarding the scope, amount, and limits of the applicable benefit.</p>
                        </div>

                        <div className='privacyData' id='roadside_4'>
                            <h2>Benefit Period</h2>
                            <p>Roadside Services apply only during the active benefit period associated with the applicable rental, booking, or Roadside Plan.</p>
                            <p>Unless otherwise stated in the applicable Roadside Plan:</p>
                            <ul>
                                <li>Benefits begin when the applicable rental period or Roadside Plan becomes active</li>
                                <li>Benefits end when the rental period or Roadside Plan expires, terminates, or is cancelled</li>
                                <li>Events occurring before activation or after expiration are not covered</li>
                                <li>Purchasing Roadside Services after a breakdown, disablement, or roadside event has already occurred does not make that existing event eligible for service</li>
                            </ul>
                            <p>The applicable transaction record may be used to determine when the Roadside Plan began and ended.</p>
                        </div>

                        <div className='privacyData' id='roadside_5'>
                            <h2>Requesting Roadside Assistance</h2>
                            <p>To request Roadside Services or ask questions about your benefits, contact the authorized Dispatch Center at:</p>
                            <p><strong><a href="tel:+18885168753">(888) 516-8753</a></strong></p>
                            <p>You must request assistance through the Dispatch Center before independently arranging roadside service.</p>
                            <p>When requesting assistance, you must provide accurate and complete information regarding:</p>
                            <ul>
                                <li>Your identity and contact information</li>
                                <li>The Covered Vehicle</li>
                                <li>The Covered Vehicle’s location</li>
                                <li>The nature of the Covered Emergency</li>
                                <li>The vehicle’s condition</li>
                                <li>Visible damage</li>
                                <li>Any collision or safety concerns</li>
                                <li>Vehicle modifications</li>
                                <li>Vehicle size, weight, height, or clearance limitations</li>
                                <li>Whether the vehicle is carrying cargo or attached equipment</li>
                                <li>Accessibility restrictions</li>
                                <li>The number and condition of the vehicle’s tires</li>
                                <li>Whether a serviceable spare tire is available</li>
                                <li>Whether the vehicle is electric, hybrid, or requires special towing procedures</li>
                                <li>Any other information reasonably requested by the Dispatch Center</li>
                            </ul>
                            <p>Providing incomplete, inaccurate, or misleading information may result in delayed service, refused service, cancellation of the dispatch, or additional charges.</p>
                        </div>

                        <div className='privacyData' id='roadside_6'>
                            <h2>Roadside Services Are Not Emergency Services</h2>
                            <p>Rentid Roadside Services is not a police, fire, medical, rescue, accident-response, or emergency-response service.</p>
                            <p>If there is:</p>
                            <ul>
                                <li>An accident</li>
                                <li>An injury</li>
                                <li>A fire</li>
                                <li>A fuel leak</li>
                                <li>A hazardous-material condition</li>
                                <li>A vehicle located in an active traffic lane</li>
                                <li>An immediate threat to people or property</li>
                                <li>A suspected crime</li>
                                <li>Any other dangerous or emergency situation</li>
                            </ul>
                            <p>You should contact 911 or the appropriate local emergency authority before requesting Roadside Services.</p>
                            <p>The Dispatch Center and Service Providers are not substitutes for public emergency services.</p>
                        </div>

                        <div className='privacyData' id='roadside_7'>
                            <h2>Vehicle Attendance and Safety</h2>
                            <p>You or another Authorized Driver should remain with the Covered Vehicle until the Service Provider arrives unless remaining with the vehicle would be unsafe.</p>
                            <p>If it is unsafe to remain with the vehicle:</p>
                            <ul>
                                <li>Move to a safe location when possible</li>
                                <li>Contact emergency authorities when appropriate</li>
                                <li>Tell the Dispatch Center where you will be waiting</li>
                                <li>Follow reasonable safety instructions</li>
                            </ul>
                            <p>Roadside service may be delayed, refused, or unavailable when:</p>
                            <ul>
                                <li>The Covered Vehicle is unattended</li>
                                <li>The Service Provider cannot confirm authorization to access the vehicle</li>
                                <li>The person requesting service cannot provide proof of lawful possession</li>
                                <li>The location is unsafe</li>
                                <li>The Service Provider cannot reasonably locate or access the vehicle</li>
                            </ul>
                        </div>

                        <div className='privacyData' id='roadside_8'>
                            <h2>Third-Party Administration and Independent Service Providers</h2>
                            <p>Rentid may use third-party program administrators, Dispatch Centers, towing networks, locksmith networks, roadside technicians, repair facilities, and other Service Providers to administer or perform Roadside Services.</p>
                            <p>Service Providers are independent contractors. They are not employees, agents, joint venturers, partners, or representatives of Rentid and do not have authority to bind Rentid.</p>
                            <p>Rentid does not control the methods, equipment, routes, staffing, scheduling, or manner in which an independent Service Provider performs its work.</p>
                            <p>To the fullest extent permitted by applicable law, Rentid is not responsible for the acts, omissions, negligence, misconduct, delays, representations, workmanship, pricing, property damage, personal injury, or other conduct of an independent Service Provider.</p>
                            <p>Any concern or damage claim arising from services performed by a Service Provider should be reported promptly to the Service Provider and Rentid or the applicable program administrator.</p>
                            <p>Nothing in these Roadside Terms eliminates any right or remedy that cannot lawfully be waived.</p>
                        </div>

                        <div className='privacyData' id='roadside_9'>
                            <h2>No Guarantee of Successful Service</h2>
                            <p>Dispatching a Service Provider does not guarantee that:</p>
                            <ul>
                                <li>The Covered Vehicle can be started</li>
                                <li>The Covered Vehicle can be unlocked</li>
                                <li>A tire can be changed</li>
                                <li>A vehicle can be safely recovered</li>
                                <li>The Covered Vehicle can be repaired at the roadside</li>
                                <li>A requested destination will accept the vehicle</li>
                                <li>A repair facility will be open or available</li>
                                <li>A service can be completed using standard roadside equipment</li>
                                <li>The vehicle will be returned to operating condition</li>
                                <li>Additional service will not be required</li>
                            </ul>
                            <p>A Service Provider may stop or refuse service when it reasonably determines that the service cannot be performed safely, legally, or without a material risk of additional damage.</p>
                        </div>

                        <div className='privacyData' id='roadside_10'>
                            <h2>Prior Authorization Required</h2>
                            <p>You must contact the Dispatch Center before arranging roadside service independently.</p>
                            <p>If the Dispatch Center cannot arrange service through the authorized network, it may permit you to obtain service independently. You must receive prior authorization and an authorization or reference number before arranging independent service.</p>
                            <p>Services obtained outside the authorized dispatch process are not covered or reimbursable unless they were authorized in advance.</p>
                            <p>Possession of a receipt does not create a right to coverage or reimbursement.</p>
                            <p>Rentid Roadside Services is not a general roadside reimbursement program.</p>
                        </div>

                        <div className='privacyData' id='roadside_11'>
                            <h2>Reimbursement of Authorized Services</h2>
                            <p>When independent service is authorized in advance, reimbursement may be available subject to:</p>
                            <ul>
                                <li>The selected Roadside Plan</li>
                                <li>The applicable benefit limit</li>
                                <li>The amount authorized by the Dispatch Center</li>
                                <li>Verification that the service was necessary and eligible</li>
                                <li>Submission of required documentation</li>
                                <li>Compliance with these Roadside Terms</li>
                            </ul>
                            <p>You may be required to submit:</p>
                            <ul>
                                <li>The authorization or reference number</li>
                                <li>An itemized receipt marked paid</li>
                                <li>Proof of payment</li>
                                <li>The name and contact information of the Service Provider</li>
                                <li>The service location</li>
                                <li>The date and time of service</li>
                                <li>The Covered Vehicle information</li>
                                <li>A description of the Covered Emergency</li>
                                <li>Any additional information reasonably required to evaluate the request</li>
                            </ul>
                            <p>A reimbursement request must be submitted within the period specified in the applicable Roadside Plan or reimbursement instructions. If no period is specified, the request should be submitted promptly after the service is completed.</p>
                            <p>Reimbursement is limited to the lesser of:</p>
                            <ul>
                                <li>The eligible amount actually paid</li>
                                <li>The amount authorized</li>
                                <li>The applicable Roadside Plan benefit</li>
                                <li>The reasonable and customary cost of the covered service</li>
                            </ul>
                            <p>Non-covered charges, unauthorized services, and amounts exceeding the applicable benefit remain your responsibility.</p>
                        </div>

                        <div className='privacyData' id='roadside_12'>
                            <h2>Towing Assistance</h2>
                            <p>When towing is necessary because of a Covered Emergency, towing assistance may be provided in accordance with the selected Roadside Plan.</p>
                            <p>The selected Roadside Plan determines:</p>
                            <ul>
                                <li>The permitted towing destination</li>
                                <li>Any towing or service limit</li>
                                <li>The applicable maximum benefit</li>
                                <li>The number of eligible Occurrences</li>
                                <li>Any customer payment responsibility</li>
                                <li>Additional restrictions</li>
                            </ul>
                            <p>Depending on the Roadside Plan, the Covered Vehicle may be towed to:</p>
                            <ul>
                                <li>A qualifying repair facility</li>
                                <li>A destination selected by you</li>
                                <li>A location determined during dispatch</li>
                                <li>Another destination permitted under the applicable plan</li>
                            </ul>
                            <p>You are responsible for charges that are not included in the selected Roadside Plan, including charges for:</p>
                            <ul>
                                <li>Additional towing</li>
                                <li>Additional distance</li>
                                <li>Additional labor</li>
                                <li>Specialty towing equipment</li>
                                <li>Dollies or flatbed equipment</li>
                                <li>Vehicle recovery</li>
                                <li>Heavy-duty service</li>
                                <li>Storage</li>
                                <li>Waiting time</li>
                                <li>Administrative services</li>
                                <li>Toll charges</li>
                                <li>Destination changes</li>
                                <li>Restricted-access service</li>
                                <li>Additional passengers</li>
                                <li>Cargo handling</li>
                                <li>Any other non-covered service</li>
                            </ul>
                            <p>A change in destination after a Service Provider has been dispatched may result in additional charges or a new service request.</p>
                        </div>

                        <div className='privacyData' id='roadside_13'>
                            <h2>Repair Facilities and Towing Destinations</h2>
                            <p>Rentid or the Dispatch Center may identify or facilitate towing to a repair facility or other destination as part of the applicable Roadside Plan.</p>
                            <p>The identification or selection of a location does not constitute a recommendation, inspection, certification, endorsement, representation, or guarantee regarding that location’s:</p>
                            <ul>
                                <li>Availability</li>
                                <li>Licensing</li>
                                <li>Qualifications</li>
                                <li>Pricing</li>
                                <li>Workmanship</li>
                                <li>Business practices</li>
                                <li>Security</li>
                                <li>Hours of operation</li>
                                <li>Ability to accept the Covered Vehicle</li>
                                <li>Ability to diagnose or repair the vehicle</li>
                            </ul>
                            <p>You remain responsible for confirming that a requested destination is open, accessible, willing to accept the Covered Vehicle, and suitable for the vehicle.</p>
                            <p>Rentid is not responsible for repair services, repair charges, storage charges, facility disputes, or damage occurring after the Covered Vehicle is delivered to a destination.</p>
                        </div>

                        <div className='privacyData' id='roadside_14'>
                            <h2>Flat Tire Assistance</h2>
                            <p>If the Covered Vehicle has a flat tire, assistance may be provided to remove the flat tire and install an inflated and serviceable spare tire supplied with the Covered Vehicle.</p>
                            <p>Flat tire assistance does not include:</p>
                            <ul>
                                <li>Tire repair</li>
                                <li>Tire replacement</li>
                                <li>The cost of a replacement tire</li>
                                <li>Wheel repair or replacement</li>
                                <li>Tire mounting or balancing</li>
                                <li>Installation of a customer-supplied replacement tire</li>
                                <li>Service when no inflated and serviceable spare tire is available</li>
                                <li>Service when the required wheel-lock key, adapter, jack point, or tools are unavailable</li>
                                <li>Service involving multiple damaged tires</li>
                                <li>Service when the wheel, suspension, braking system, or surrounding area is unsafe</li>
                                <li>Specialty equipment or labor beyond an ordinary roadside tire change</li>
                            </ul>
                            <p>If a serviceable spare tire is unavailable or the tire cannot be changed safely, towing may be provided in accordance with the selected Roadside Plan.</p>
                        </div>

                        <div className='privacyData' id='roadside_15'>
                            <h2>Fuel, Oil, Fluid, and Water Delivery</h2>
                            <p>An emergency supply of fuel, oil, water, coolant, or another necessary fluid may be delivered when the Covered Vehicle is disabled because the applicable supply is depleted.</p>
                            <p>Unless expressly included in the selected Roadside Plan, the benefit covers only the eligible delivery service.</p>
                            <p>You are responsible for the cost of:</p>
                            <ul>
                                <li>Fuel</li>
                                <li>Oil</li>
                                <li>Water</li>
                                <li>Coolant</li>
                                <li>Lubricants</li>
                                <li>Vehicle fluids</li>
                                <li>Containers</li>
                                <li>Parts</li>
                                <li>Materials</li>
                                <li>Related installation or disposal charges</li>
                            </ul>
                            <p>Delivery is subject to product availability, vehicle compatibility, local laws, environmental requirements, and safety conditions.</p>
                        </div>

                        <div className='privacyData' id='roadside_16'>
                            <h2>Lockout Assistance</h2>
                            <p>If an Authorized Driver’s keys are locked inside the Covered Vehicle, assistance may be provided to attempt entry.</p>
                            <p>You may be required to provide proof of:</p>
                            <ul>
                                <li>Identity</li>
                                <li>Lawful possession</li>
                                <li>Rental authorization</li>
                                <li>Vehicle registration</li>
                                <li>Permission to access the Covered Vehicle</li>
                            </ul>
                            <p>Lockout assistance does not include:</p>
                            <ul>
                                <li>Replacement keys</li>
                                <li>Key duplication</li>
                                <li>Key cutting</li>
                                <li>Key programming</li>
                                <li>Transponder keys</li>
                                <li>Key fobs</li>
                                <li>Smart keys</li>
                                <li>Lock repair or replacement</li>
                                <li>Ignition repair or replacement</li>
                                <li>Service for lost, stolen, damaged, or inoperative keys unless expressly included in the Roadside Plan</li>
                                <li>Service when entry cannot be attempted without a substantial risk of damage</li>
                            </ul>
                            <p>Neither Rentid nor the Service Provider guarantees that entry can be gained without damage.</p>
                        </div>

                        <div className='privacyData' id='roadside_17'>
                            <h2>Battery Assistance</h2>
                            <p>If the Covered Vehicle is disabled because of battery failure, a Service Provider may attempt to jump-start the vehicle.</p>
                            <p>Battery assistance does not include:</p>
                            <ul>
                                <li>Battery replacement</li>
                                <li>The cost of a replacement battery</li>
                                <li>Battery charging</li>
                                <li>Battery installation</li>
                                <li>Electrical diagnosis</li>
                                <li>Electrical repair</li>
                                <li>Replacement parts</li>
                                <li>Service for a damaged or leaking battery</li>
                                <li>Service that conflicts with manufacturer instructions</li>
                                <li>A guarantee that the vehicle will restart or remain operational</li>
                            </ul>
                            <p>If the Covered Vehicle cannot be safely started, towing may be provided in accordance with the selected Roadside Plan.</p>
                        </div>

                        <div className='privacyData' id='roadside_18'>
                            <h2>Electric and Hybrid Vehicles</h2>
                            <p>Roadside service for electric and hybrid vehicles is subject to Service Provider capability, equipment availability, manufacturer requirements, and the selected Roadside Plan.</p>
                            <p>Unless expressly included in the Roadside Plan, Roadside Services do not include:</p>
                            <ul>
                                <li>Mobile electric-vehicle charging</li>
                                <li>The cost of electricity or charging</li>
                                <li>High-voltage battery repair</li>
                                <li>High-voltage system diagnosis</li>
                                <li>Battery-pack replacement</li>
                                <li>Charging equipment repair</li>
                                <li>Charging-port repair</li>
                                <li>Removal of a vehicle from charging equipment</li>
                            </ul>
                            <p>A depleted electric-vehicle battery may require towing to an available charging location or another permitted destination.</p>
                            <p>You are responsible for informing the Dispatch Center that the Covered Vehicle is electric or hybrid and disclosing any manufacturer-required towing procedures.</p>
                            <p>Service may be refused when the required equipment, including a flatbed tow vehicle or wheel dollies, is unavailable.</p>
                            <p>Rentid does not guarantee that a charging destination will be available, compatible, operational, accessible, or capable of accepting the Covered Vehicle.</p>
                        </div>

                        <div className='privacyData' id='roadside_19'>
                            <h2>Winching and Extrication Assistance</h2>
                            <p>Winching or extrication assistance may be provided when the Covered Vehicle is stuck near a regularly maintained road and can be accessed safely using ordinary roadside equipment.</p>
                            <p>Coverage is subject to the selected Roadside Plan.</p>
                            <p>Winching and extrication assistance does not include:</p>
                            <ul>
                                <li>Off-road recovery</li>
                                <li>Recovery from beaches, fields, forests, trails, construction areas, or unmaintained locations</li>
                                <li>Recovery from flooded, submerged, unstable, or environmentally sensitive areas</li>
                                <li>Recovery requiring cranes, multiple recovery vehicles, specialty equipment, or extraordinary labor</li>
                                <li>Recovery involving a rollover</li>
                                <li>Recovery involving substantial structural damage</li>
                                <li>Recovery involving hazardous materials</li>
                                <li>Recovery where the vehicle is not accessible from a regularly maintained road</li>
                                <li>Recovery that may endanger people or property</li>
                                <li>Recovery when access is restricted or unsafe</li>
                            </ul>
                        </div>

                        <div className='privacyData' id='roadside_20'>
                            <h2>Vehicle Eligibility</h2>
                            <p>Roadside Services apply only to a vehicle that qualifies as a Covered Vehicle under the selected Roadside Plan.</p>
                            <p>Eligibility may depend on:</p>
                            <ul>
                                <li>Vehicle type</li>
                                <li>Vehicle age</li>
                                <li>Vehicle size</li>
                                <li>Gross vehicle weight</li>
                                <li>Vehicle height or length</li>
                                <li>Vehicle condition</li>
                                <li>Vehicle registration</li>
                                <li>Vehicle use</li>
                                <li>Vehicle modifications</li>
                                <li>Commercial or specialty equipment</li>
                                <li>Number of wheels or axles</li>
                                <li>Towing requirements</li>
                                <li>Geographic location</li>
                                <li>Accessibility</li>
                                <li>Service Provider equipment limitations</li>
                            </ul>
                            <p>Unless expressly included in the applicable Roadside Plan, Roadside Services may not be available for:</p>
                            <ul>
                                <li>Antique or classic vehicles</li>
                                <li>Recreational vehicles</li>
                                <li>Motorhomes</li>
                                <li>Buses</li>
                                <li>Limousines</li>
                                <li>Heavy commercial vehicles</li>
                                <li>Vehicles requiring heavy-duty towing equipment</li>
                                <li>Vehicles used for racing or competitive events</li>
                                <li>Vehicles with substantial aftermarket modifications</li>
                                <li>Camping trailers</li>
                                <li>Travel trailers</li>
                                <li>Utility trailers</li>
                                <li>Vehicles or equipment being towed by the Covered Vehicle</li>
                                <li>Attached commercial equipment</li>
                                <li>A vehicle not identified in the applicable transaction</li>
                            </ul>
                            <p>The dispatch of a Service Provider does not constitute final confirmation that the vehicle is eligible or serviceable.</p>
                        </div>

                        <div className='privacyData' id='roadside_21'>
                            <h2>Customer Approval and Payment of Additional Charges</h2>
                            <p>The Roadside Plan may cover only part of the total cost of a requested service.</p>
                            <p>Before performing a service expected to exceed the applicable benefit, the Dispatch Center or Service Provider may request your approval of additional charges.</p>
                            <p>When reasonably possible, you will be informed of estimated non-covered or excess charges before the service is performed. Estimates may change if:</p>
                            <ul>
                                <li>The information provided during dispatch was inaccurate or incomplete</li>
                                <li>Additional labor or equipment is required</li>
                                <li>The vehicle’s condition is different from what was reported</li>
                                <li>The vehicle is more difficult to access or recover than expected</li>
                                <li>The destination changes</li>
                                <li>Waiting or storage charges apply</li>
                                <li>Other unforeseen circumstances arise</li>
                            </ul>
                            <p>You are responsible for all approved, non-covered, and excess charges.</p>
                            <p>A Service Provider may require payment directly from you before completing or releasing the Covered Vehicle.</p>
                        </div>

                        <div className='privacyData' id='roadside_22'>
                            <h2>Payment Authorization</h2>
                            <p>By requesting or approving a roadside service that involves a non-covered or excess charge, you authorize Rentid, the applicable rental operator, the program administrator, or the Service Provider, as applicable, to charge the payment method associated with your rental or roadside transaction for:</p>
                            <ul>
                                <li>Charges you approve</li>
                                <li>Amounts exceeding the Roadside Plan benefit</li>
                                <li>Non-covered services you request</li>
                                <li>Parts, fuel, fluids, materials, or products</li>
                                <li>Additional labor or equipment</li>
                                <li>Storage or waiting charges</li>
                                <li>Destination changes</li>
                                <li>Charges resulting from inaccurate or incomplete information you provided</li>
                                <li>Other amounts that you expressly authorize</li>
                            </ul>
                            <p>When reasonably available, the amount or estimated amount will be disclosed before the charge is incurred.</p>
                            <p>This section does not authorize unrelated charges or recurring withdrawals that are not separately authorized.</p>
                            <p>You remain responsible for an authorized charge even if the associated payment method is declined, expired, reversed, disputed, or otherwise unavailable.</p>
                        </div>

                        <div className='privacyData' id='roadside_23'>
                            <h2>Cancellation and Refunds</h2>
                            <p>The cancellation and refund rules displayed during checkout or included in the selected Roadside Plan will apply.</p>
                            <p>Unless otherwise stated in the applicable transaction:</p>
                            <ul>
                                <li>A Roadside Plan may be cancelled before the associated rental or benefit period begins</li>
                                <li>No refund will be available after Roadside Services have been requested, dispatched, used, or provided</li>
                                <li>No refund will be available for an unused portion of a Roadside Plan after the applicable rental or benefit period begins</li>
                                <li>Cancellation of the underlying rental may cancel the associated Roadside Plan</li>
                                <li>A refund, when available, will generally be returned to the original payment method</li>
                                <li>Processing times may depend on the payment provider or financial institution</li>
                            </ul>
                            <p>No refund is owed merely because:</p>
                            <ul>
                                <li>A Covered Emergency did not occur</li>
                                <li>Roadside Services were not requested</li>
                                <li>A Service Provider could not restore the vehicle to operation</li>
                                <li>Service was delayed due to circumstances outside reasonable control</li>
                                <li>The requested service was excluded</li>
                                <li>The Covered Vehicle was ineligible</li>
                                <li>You declined to pay an excess or non-covered charge</li>
                                <li>You independently arranged service without prior authorization</li>
                            </ul>
                            <p>Nothing in this section limits any cancellation or refund right required by applicable law.</p>
                        </div>

                        <div className='privacyData' id='roadside_24'>
                            <h2>General Exclusions</h2>
                            <p>Unless expressly included in the selected Roadside Plan, Roadside Services do not cover the following.</p>
                            <h3>Illegal, Fraudulent, or Unsafe Conduct</h3>
                            <ul>
                                <li>An event arising from the use of intoxicants, narcotics, or unlawful controlled substances</li>
                                <li>Use of the Covered Vehicle in the commission of a crime</li>
                                <li>Conduct that violates applicable law</li>
                                <li>Intentional misuse or abuse of the Covered Vehicle</li>
                                <li>Fraud or material misrepresentation</li>
                                <li>A staged or fabricated roadside event</li>
                                <li>Service requested for an unauthorized driver</li>
                                <li>A condition creating an unreasonable safety risk</li>
                                <li>A vehicle that cannot be safely serviced or towed without a material risk of additional damage</li>
                            </ul>
                            <h3>Parts, Products, Repairs, and Materials</h3>
                            <ul>
                                <li>Replacement keys or key fobs</li>
                                <li>Key programming</li>
                                <li>Fuel</li>
                                <li>Oil</li>
                                <li>Water</li>
                                <li>Coolant</li>
                                <li>Lubricants</li>
                                <li>Vehicle fluids</li>
                                <li>Tires</li>
                                <li>Wheels</li>
                                <li>Batteries</li>
                                <li>Replacement parts</li>
                                <li>Repair materials</li>
                                <li>Diagnostic services</li>
                                <li>Mechanical repairs</li>
                                <li>Electrical repairs</li>
                                <li>Body repairs</li>
                                <li>Labor not expressly included in the selected Roadside Plan</li>
                                <li>Installation, removal, disposal, or storage of parts or materials</li>
                            </ul>
                            <h3>Non-Emergency Services</h3>
                            <ul>
                                <li>Non-emergency towing</li>
                                <li>Scheduled transportation</li>
                                <li>Vehicle relocation for convenience</li>
                                <li>Routine maintenance</li>
                                <li>Mechanical diagnosis</li>
                                <li>Repeated service requests arising from a known condition that has not been repaired</li>
                                <li>Tire mounting or removal when no Covered Emergency exists</li>
                                <li>Installation or removal of snow tires or chains</li>
                                <li>Snow removal or shoveling around the Covered Vehicle</li>
                                <li>Pre-purchase or post-purchase inspections</li>
                                <li>Vehicle delivery</li>
                                <li>Vehicle repossession</li>
                                <li>Services requested primarily for convenience</li>
                            </ul>
                            <h3>Damage and External Events</h3>
                            <p>Unless expressly included in the selected Roadside Plan:</p>
                            <ul>
                                <li>Fire</li>
                                <li>Flood</li>
                                <li>Water immersion</li>
                                <li>Vandalism</li>
                                <li>Collision</li>
                                <li>Theft or attempted theft</li>
                                <li>Civil disturbance</li>
                                <li>Natural disaster</li>
                                <li>Hazardous materials</li>
                                <li>Severe weather</li>
                                <li>Structural collapse</li>
                                <li>Environmental contamination</li>
                                <li>Events requiring emergency or specialized recovery</li>
                            </ul>
                            <h3>Towing and Repair Restrictions</h3>
                            <ul>
                                <li>Towing from a repair facility, body shop, garage, service station, impound lot, storage facility, auction, salvage yard, or similar location</li>
                                <li>Repair work performed at a repair facility</li>
                                <li>Towing by an unlicensed or unauthorized party</li>
                                <li>Vehicle storage charges</li>
                                <li>A second tow for the same disablement</li>
                                <li>Transportation after the Covered Vehicle has been delivered to an approved destination</li>
                                <li>Transfer from one facility to another</li>
                                <li>Charges resulting from a destination’s refusal or inability to accept the Covered Vehicle</li>
                                <li>Transportation required solely because a destination is closed</li>
                            </ul>
                            <h3>Inaccessible or Unmaintained Locations</h3>
                            <ul>
                                <li>Beaches</li>
                                <li>Fields</li>
                                <li>Forests</li>
                                <li>Trails</li>
                                <li>Off-road areas</li>
                                <li>Unmaintained roads</li>
                                <li>Restricted areas</li>
                                <li>Closed roads</li>
                                <li>Unsafe construction zones</li>
                                <li>Parking structures or locations that cannot accommodate ordinary roadside equipment</li>
                                <li>Areas affected by height, weight, width, clearance, or access restrictions</li>
                                <li>Locations where access is prevented by gates, private-property restrictions, weather, flooding, law enforcement, or circumstances outside reasonable control</li>
                            </ul>
                            <h3>Law-Enforcement and Impound Tows</h3>
                            <ul>
                                <li>Towing directed by law enforcement</li>
                                <li>Traffic-obstruction removal</li>
                                <li>Impoundment</li>
                                <li>Abandonment</li>
                                <li>Illegal parking</li>
                                <li>Parking violations</li>
                                <li>Registration or licensing violations</li>
                                <li>Repossession</li>
                                <li>Towing resulting from a governmental order or violation of law</li>
                            </ul>
                            <h3>Unauthorized Services</h3>
                            <ul>
                                <li>Services arranged without first contacting the Dispatch Center</li>
                                <li>Services obtained independently without prior authorization</li>
                                <li>Charges incurred before authorization is issued</li>
                                <li>Charges exceeding the amount authorized</li>
                                <li>Services performed by an unlicensed or unauthorized party</li>
                                <li>Services not covered by the selected Roadside Plan</li>
                                <li>Service requested after the applicable benefit period has ended</li>
                            </ul>
                        </div>

                        <div className='privacyData' id='roadside_25'>
                            <h2>Service Availability and Delays</h2>
                            <p>Service arrival and completion times are estimates only and are not guaranteed.</p>
                            <p>Roadside Services may be delayed, restricted, cancelled, or unavailable because of:</p>
                            <ul>
                                <li>Severe weather</li>
                                <li>Traffic</li>
                                <li>High service demand</li>
                                <li>Service Provider shortages</li>
                                <li>Remote location</li>
                                <li>Road closures</li>
                                <li>Public emergencies</li>
                                <li>Natural disasters</li>
                                <li>Unsafe conditions</li>
                                <li>Government restrictions</li>
                                <li>Communication outages</li>
                                <li>Restricted access</li>
                                <li>Equipment limitations</li>
                                <li>Labor disruptions</li>
                                <li>Other circumstances outside reasonable control</li>
                            </ul>
                            <p>Rentid does not guarantee that Roadside Services will arrive or be completed within a particular period.</p>
                        </div>

                        <div className='privacyData' id='roadside_26'>
                            <h2>Customer Responsibilities</h2>
                            <p>You are responsible for:</p>
                            <ul>
                                <li>Reviewing the Roadside Plan before purchasing or selecting it</li>
                                <li>Confirming that the vehicle and driver are eligible</li>
                                <li>Providing accurate information about the Covered Vehicle</li>
                                <li>Providing an accurate vehicle location</li>
                                <li>Describing the Covered Emergency accurately</li>
                                <li>Disclosing vehicle damage, modifications, loading conditions, low clearance, or specialty equipment</li>
                                <li>Informing the Dispatch Center of manufacturer-required towing procedures</li>
                                <li>Disclosing safety risks</li>
                                <li>Obtaining permission for service on private property</li>
                                <li>Providing legal and physical access to the Covered Vehicle</li>
                                <li>Remaining available by telephone or other provided contact method</li>
                                <li>Removing personal property when reasonably possible</li>
                                <li>Following reasonable dispatch and safety instructions</li>
                                <li>Paying non-covered and excess charges</li>
                                <li>Ensuring that only an Authorized Driver requests service</li>
                                <li>Using Roadside Services only for a legitimate Covered Emergency</li>
                            </ul>
                            <p>You are also responsible for securing personal belongings. Rentid and Service Providers are not responsible for lost, stolen, or damaged personal property left in or around the Covered Vehicle, except to the extent responsibility cannot be excluded under applicable law.</p>
                        </div>

                        <div className='privacyData' id='roadside_27'>
                            <h2>Roadside Services Apply Only to the Covered Vehicle</h2>
                            <p>Roadside Services apply only to the Covered Vehicle identified in the applicable rental, booking, Roadside Plan, or service transaction.</p>
                            <p>The benefit may not be:</p>
                            <ul>
                                <li>Transferred to another vehicle</li>
                                <li>Used for another booking</li>
                                <li>Used for another rental</li>
                                <li>Sold or transferred to another person</li>
                                <li>Shared with another vehicle</li>
                                <li>Used for a vehicle not identified as the Covered Vehicle</li>
                            </ul>
                        </div>

                        <div className='privacyData' id='roadside_28'>
                            <h2>Occurrence Limits</h2>
                            <p>The number of Roadside Service Occurrences available is determined by the selected Roadside Plan.</p>
                            <p>Multiple requests arising from the same mechanical condition, breakdown, incident, or disablement may be treated as one Occurrence.</p>
                            <p>A service request may be denied when:</p>
                            <ul>
                                <li>The applicable Occurrence limit has been reached</li>
                                <li>Repeated requests arise from a known condition that has not been repaired</li>
                                <li>The request relates to routine maintenance</li>
                                <li>The Roadside Plan is being misused</li>
                                <li>The applicable benefit period has ended</li>
                                <li>The request is otherwise excluded</li>
                            </ul>
                        </div>

                        <div className='privacyData' id='roadside_29'>
                            <h2>Abuse, Fraud, and Misuse</h2>
                            <p>Rentid may deny, suspend, limit, or cancel Roadside Services when it reasonably determines that:</p>
                            <ul>
                                <li>A request is fraudulent</li>
                                <li>Information provided is materially false or misleading</li>
                                <li>Roadside Services are being abused or misused</li>
                                <li>The Covered Vehicle has a known condition that has not been repaired</li>
                                <li>Repeated requests result from a failure to perform routine maintenance</li>
                                <li>The person requesting service is not authorized</li>
                                <li>The service is requested for an ineligible vehicle</li>
                                <li>The Roadside Plan was purchased after the roadside event occurred</li>
                                <li>The request is made for commercial resale or unauthorized benefit sharing</li>
                                <li>The request violates these Roadside Terms</li>
                            </ul>
                            <p>Rentid may seek recovery of amounts paid or incurred as a result of fraud, misuse, or material misrepresentation.</p>
                        </div>

                        <div className='privacyData' id='roadside_30'>
                            <h2>Not Insurance or a Vehicle Warranty</h2>
                            <p>Rentid Roadside Services is a roadside assistance service. It is not:</p>
                            <ul>
                                <li>Automobile liability insurance</li>
                                <li>Physical damage insurance</li>
                                <li>Collision or comprehensive insurance</li>
                                <li>Mechanical breakdown insurance</li>
                                <li>A vehicle warranty</li>
                                <li>A manufacturer’s warranty</li>
                                <li>A guarantee of vehicle condition</li>
                                <li>A maintenance plan</li>
                                <li>A substitute for required insurance</li>
                                <li>A substitute for compliance with financial responsibility laws</li>
                            </ul>
                            <p>Roadside Services do not cover vehicle repairs, collision losses, bodily injury, property damage, loss of use, diminished value, rental expense, business interruption, or other losses unless expressly stated in the selected Roadside Plan.</p>
                        </div>

                        <div className='privacyData' id='roadside_31'>
                            <h2>Disclaimer of Warranties</h2>
                            <p>To the fullest extent permitted by applicable law, Roadside Services are provided on an “as available” basis.</p>
                            <p>Rentid disclaims all representations and warranties not expressly stated in these Roadside Terms, including implied warranties of merchantability, fitness for a particular purpose, title, non-infringement, availability, timeliness, quality, and satisfactory performance.</p>
                            <p>Rentid does not warrant that:</p>
                            <ul>
                                <li>A Service Provider will always be available</li>
                                <li>Service will arrive within a particular period</li>
                                <li>Service will be uninterrupted or error-free</li>
                                <li>A vehicle can be repaired or restored to operation</li>
                                <li>A destination will accept the vehicle</li>
                                <li>A Service Provider will have every required part or piece of equipment</li>
                                <li>Roadside Services will meet every customer expectation</li>
                            </ul>
                            <p>Some jurisdictions do not permit certain warranty disclaimers. In those jurisdictions, these disclaimers apply only to the extent permitted by law.</p>
                        </div>

                        <div className='privacyData' id='roadside_32'>
                            <h2>Limitation of Liability</h2>
                            <p>To the fullest extent permitted by applicable law, Rentid will not be liable for indirect, incidental, consequential, special, exemplary, punitive, or enhanced damages arising from or related to Roadside Services, including:</p>
                            <ul>
                                <li>Loss of use</li>
                                <li>Lost profits</li>
                                <li>Lost revenue</li>
                                <li>Lost business opportunities</li>
                                <li>Missed reservations</li>
                                <li>Missed travel</li>
                                <li>Replacement transportation</li>
                                <li>Lodging</li>
                                <li>Personal inconvenience</li>
                                <li>Loss of data</li>
                                <li>Diminished vehicle value</li>
                                <li>Damage arising from delay or service unavailability</li>
                            </ul>
                            <p>Except where prohibited by law, Rentid’s total liability arising from a Roadside Service event will not exceed the amount paid for the applicable Roadside Plan or the applicable roadside benefit, whichever is greater.</p>
                            <p>This limitation does not apply to liability that cannot lawfully be limited or excluded.</p>
                        </div>

                        <div className='privacyData' id='roadside_33'>
                            <h2>Indemnification</h2>
                            <p>To the fullest extent permitted by applicable law, you agree to defend, indemnify, and hold harmless Rentid, its affiliates, officers, directors, employees, contractors, program administrators, and representatives from third-party claims, liabilities, losses, damages, penalties, costs, and reasonable legal fees arising from:</p>
                            <ul>
                                <li>Your misuse of Roadside Services</li>
                                <li>Your violation of these Roadside Terms</li>
                                <li>Fraudulent, false, or misleading information you provide</li>
                                <li>Your unlawful conduct</li>
                                <li>Your failure to disclose a material safety risk</li>
                                <li>A claim relating to a vehicle or property you were not authorized to use</li>
                                <li>Your violation of another person’s rights</li>
                            </ul>
                            <p>This provision does not require you to indemnify any party for its own conduct to the extent such an obligation is prohibited by law.</p>
                        </div>

                        <div className='privacyData' id='roadside_34'>
                            <h2>Changes to Roadside Services</h2>
                            <p>Rentid may modify, replace, suspend, or discontinue:</p>
                            <ul>
                                <li>Roadside Plans</li>
                                <li>Benefit features</li>
                                <li>Service areas</li>
                                <li>Dispatch procedures</li>
                                <li>Eligibility requirements</li>
                                <li>Towing options</li>
                                <li>Service Provider networks</li>
                                <li>Administrative processes</li>
                                <li>Other Roadside Service terms</li>
                            </ul>
                            <p>Changes will be made in accordance with applicable law.</p>
                            <p>The Roadside Terms and plan details presented for the applicable transaction will govern the Roadside Plan purchased or selected for that transaction.</p>
                            <p>A change will not reduce a service benefit already authorized for an eligible Covered Emergency before the change took effect.</p>
                        </div>

                        <div className='privacyData' id='roadside_35'>
                            <h2>Electronic Communications and Acceptance</h2>
                            <p>You consent to receive Roadside Service communications electronically, including through:</p>
                            <ul>
                                <li>The Rentid platform</li>
                                <li>Email</li>
                                <li>Text message</li>
                                <li>In-app notification</li>
                                <li>Website notice</li>
                                <li>Other electronic methods associated with your transaction</li>
                            </ul>
                            <p>Electronic communications may include:</p>
                            <ul>
                                <li>Roadside Plan terms</li>
                                <li>Dispatch updates</li>
                                <li>Service Provider information</li>
                                <li>Estimated arrival information</li>
                                <li>Charge approvals</li>
                                <li>Receipts</li>
                                <li>Reimbursement instructions</li>
                                <li>Cancellation notices</li>
                                <li>Updates to these Roadside Terms</li>
                            </ul>
                            <p>Your electronic selection, checkbox, button press, purchase, request for service, or other electronic action indicating acceptance may constitute your agreement to these Roadside Terms.</p>
                            <p>You are responsible for maintaining accurate contact information and access to the email address and telephone number associated with your transaction.</p>
                            <p>Standard messaging and data charges may apply.</p>
                        </div>

                        <div className='privacyData' id='roadside_36'>
                            <h2>Relationship to Rentid’s General Terms</h2>
                            <p>These Roadside Terms supplement:</p>
                            <ul>
                                <li>Rentid’s general <a href="/terms">Terms of Service</a></li>
                                <li>Rentid’s <a href="/privacy">Privacy Policy</a></li>
                                <li>The applicable rental agreement</li>
                                <li>Booking and checkout terms</li>
                                <li>Vehicle eligibility requirements</li>
                                <li>Payment authorizations</li>
                                <li>The Roadside Plan details presented for the applicable transaction</li>
                            </ul>
                            <p>Rentid’s general Terms of Service, including any applicable provisions concerning dispute resolution, arbitration, class-action waiver, governing law, venue, limitation of liability, electronic communications, and account use, are incorporated into these Roadside Terms by reference.</p>
                            <p>If there is a conflict concerning the scope or amount of a roadside benefit, the specific Roadside Plan details presented for the applicable transaction will control.</p>
                            <p>If there is a conflict concerning use of the Rentid platform, dispute resolution, or general legal rights and obligations, Rentid’s general Terms of Service will control unless applicable law requires otherwise.</p>
                        </div>

                        <div className='privacyData' id='roadside_37'>
                            <h2>Assignment</h2>
                            <p>You may not assign, transfer, sell, delegate, or sublicense your Roadside Plan or any right under these Roadside Terms without Rentid’s prior written consent.</p>
                            <p>Rentid may assign or transfer its rights and obligations under these Roadside Terms to an affiliate, successor, purchaser, program administrator, or service provider as part of a merger, acquisition, reorganization, asset transfer, financing, or change in service administration.</p>
                        </div>

                        <div className='privacyData' id='roadside_38'>
                            <h2>Severability</h2>
                            <p>If any provision of these Roadside Terms is determined to be invalid, illegal, or unenforceable, that provision will be enforced to the maximum extent permitted by law.</p>
                            <p>The remaining provisions will remain in full force and effect.</p>
                        </div>

                        <div className='privacyData' id='roadside_39'>
                            <h2>No Waiver</h2>
                            <p>A failure or delay by Rentid to enforce a provision of these Roadside Terms does not waive Rentid’s right to enforce that provision or any other provision later.</p>
                            <p>A waiver is effective only if it is made in writing by an authorized representative of Rentid.</p>
                        </div>

                        <div className='privacyData' id='roadside_40'>
                            <h2>Headings</h2>
                            <p>Section headings are provided for convenience only and do not affect the interpretation of these Roadside Terms.</p>
                        </div>

                        <div className='privacyData' id='roadside_41'>
                            <h2>Entire Agreement</h2>
                            <p>These Roadside Terms, the selected Roadside Plan details, Rentid’s general Terms of Service, the applicable rental or booking terms, and any other terms incorporated by reference constitute the entire agreement regarding Rentid Roadside Services for the applicable transaction.</p>
                            <p>They replace prior or contemporaneous communications concerning the same Roadside Plan, except for representations or rights that cannot lawfully be excluded.</p>
                        </div>

                        <div className='privacyData' id='roadside_42'>
                            <h2>Contact Information</h2>
                            <p>Questions about Rentid Roadside Services or these Roadside Terms may be submitted through the contact methods provided on the Rentid website or platform.</p>
                            <p>For active roadside assistance, contact the authorized Dispatch Center at:</p>
                            <p><strong><a href="tel:+18885168753">(888) 516-8753</a></strong></p>
                            <p>Do not use general customer support channels for an immediate roadside emergency when the Dispatch Center is available.</p>
                        </div>

                        <div className='privacyData' id='roadside_43'>
                            <h2>Acceptance of Terms</h2>
                            <p>By purchasing, selecting, activating, requesting, approving, or using Rentid Roadside Services, you acknowledge that:</p>
                            <ul>
                                <li>You reviewed and agreed to these Roadside Terms</li>
                                <li>You reviewed the applicable Roadside Plan details</li>
                                <li>You understand that benefits and limitations vary by plan</li>
                                <li>You understand that Roadside Services are not insurance or emergency services</li>
                                <li>You accept responsibility for non-covered and excess charges</li>
                                <li>You authorize charges that you separately request or approve in connection with a roadside service</li>
                                <li>You agree to Rentid’s other applicable terms and policies</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
    {/* END maxBannerMain */}
    <ScrollingAnounce />
</main>
<Footer/>


    </>
  )
}

export default RoadsideTerms
